import React, { FC, ReactNode } from "react";
import { Divider, SvgIconProps, Typography } from "@mui/material";
import { SxProps } from "@mui/material";
import { PageToolbar } from "./PageToolbar";
import { useSxMergeStrict } from "shared-ts-mui";
import { Variant } from "../Variant";

export interface PageHeaderProps {
  variant: Variant;
  title?: string;
  hideTitle?: boolean;
  titleProps?: {
    sx: SxProps;
  };
  icon?: React.ComponentType<SvgIconProps>;
  children?: ReactNode;
}

export const PageHeader: FC<PageHeaderProps> = (props) => {
  const Icon = props.icon;
  const titleSx = useSxMergeStrict(
    () => [
      props.titleProps?.sx,
      {
        ml: 1,
        mr: 1,
      },
    ],
    [props.titleProps?.sx]
  );
  return (
    <PageToolbar sx={{ gap: 2 }}>
      {Icon != null && (
        <Icon
          color={"primary"}
          sx={{
            ml: 1,
            mr: props.title != null && !props.hideTitle ? 1 : undefined,
          }}
        />
      )}
      {props.title != null && !props.hideTitle && (
        <Typography
          variant={"subtitle2"}
          className={"title"}
          color={"secondary.dark"}
          component={"h1"}
          sx={titleSx}
        >
          {props.title}
        </Typography>
      )}
      {props.title != null && props.children != null && (
        <Divider
          orientation={"vertical"}
          sx={{
            opacity: "0.6",
          }}
        />
      )}
      {props.children}
    </PageToolbar>
  );
};
